import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import EmptyState from "../../components/ui/EmptyState";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { apiRequest, formatPrice } from "../../api/client";
import { useToast } from "../../context/ToastContext";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const toast = useToast();

  const load = useCallback(() => {
    setLoading(true);
    setError("");
    apiRequest(`/api/products?admin=true&search=${encodeURIComponent(search)}`, { tokenType: "admin" })
      .then((response) => setProducts(response.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [search]);

  useEffect(load, [load]);

  async function remove(id) {
    if (!window.confirm("Delete this product?")) return;
    setError("");
    try {
      const response = await apiRequest(`/api/products/${id}`, { method: "DELETE", tokenType: "admin" });
      toast?.show(response.warnings?.[0] || "Product deleted.");
      load();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="admin-page">
      <div className="admin-page-head">
        <div><span className="eyebrow">Catalog</span><h1>Products</h1></div>
        <Button to="/admin/products/new">Add Product</Button>
      </div>
      <div className="admin-filters">
        <input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search products" />
        <Button type="button" variant="secondary" onClick={load}>Search</Button>
      </div>
      {error && <p className="form-status error">{error}</p>}
      {loading ? <LoadingSpinner /> : !products.length ? <EmptyState title="No products" text="Add your first digital product." /> : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Name</th><th>Status</th><th>Price</th><th>Discount</th><th>Featured</th><th /></tr></thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.id}>
                  <td><strong>{product.name}</strong><small>{product.category}</small></td>
                  <td><span className={`status-pill status-${product.status}`}>{product.status}</span></td>
                  <td>{formatPrice(product.price)}</td>
                  <td>{product.discount_price ? formatPrice(product.discount_price) : "-"}</td>
                  <td>{product.featured ? "Yes" : "No"}</td>
                  <td className="table-actions">
                    <Link to={`/admin/products/${product.id}/edit`}>Edit</Link>
                    <button type="button" onClick={() => remove(product.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
